export default __webpack_public_path__ + "static/media/ICCT LM-Lid Production Method.edbacdfb.pdf";